/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import Store from '../../store/store';
import workPackageTypes from '../../constants/workPackageTypes';
import {
  cloneWorkPackage,
  updateWorkPackage,
  willDeleteWorkPackage,
  deleteWorkPackage,
  updateWorkPackageRank,
  updateWorkPackageLevel,
  restoreWorkPackage
} from '../../actions/workPackageActions';
import { allows } from '../../utils/authorization';

const CogMenu = (props) => {
  const { classes, result, organizationLevels } = props;
  const workPackageType = workPackageTypes[result.level];
  const allowCreate = allows('create', result);
  const allowDelete = allows('destroy', result);
  const allowRestore = allows('restore_work_packages', result) || true;
  const organizationLevel =
    result.result_type && result.result_type.organization_level_id
      ? organizationLevels.find(
          (orgLevel) => orgLevel.id === result.result_type.organization_level_id
        )
      : {};
  const organizationLevelOptions = organizationLevel
    ? organizationLevels.filter(
        (orgLevel) => orgLevel.id !== organizationLevel.id
      )
    : organizationLevels;

  return (
    <ul className={`dropdown-menu result-dropdown-menu ${classes}`}>
      <li>
        <a
          onClick={() =>
            Store.dispatch(updateWorkPackageRank(result, { position: 'start' }))
          }
        >
          <span>Send to Top</span>
        </a>
      </li>
      <li>
        <a
          onClick={() =>
            Store.dispatch(updateWorkPackageRank(result, { position: 'end' }))
          }
        >
          <span>Send to Bottom</span>
        </a>
      </li>
      <li>
        <a
          onClick={() =>
            Store.dispatch(
              updateWorkPackage(result.id, { blocked: !result.blocked })
            )
          }
        >
          <span>{result.blocked ? 'Unblock' : 'Block'}</span>
        </a>
      </li>
      {allowCreate && (
        <li>
          <a onClick={() => Store.dispatch(cloneWorkPackage(result.id))}>
            <span>Clone</span>
          </a>
        </li>
      )}
      {allowDelete && (
        <li>
          <a
            onClick={() =>
              result.level > 1
                ? Store.dispatch(willDeleteWorkPackage(result.id))
                : Store.dispatch(deleteWorkPackage(result.id))
            }
          >
            <span>{result.deleted_at ? 'Permanently Delete' : 'Delete'} </span>
          </a>
        </li>
      )}
      {allowRestore && result.deleted_at && (
        <li>
          <a onClick={() => Store.dispatch(restoreWorkPackage(result.id))}>
            <span>Restore</span>
          </a>
        </li>
      )}
      {organizationLevelOptions.reduce((list, orgLevel) => {
        if (orgLevel.deleted_at) return list;

        list.push(
          <li key={orgLevel.id}>
            <a
              onClick={() =>
                Store.dispatch(
                  updateWorkPackageLevel(result, orgLevel.level, orgLevel.id)
                )
              }
            >
              <span>Change to {orgLevel.name}</span>
            </a>
          </li>
        );
        return list;
      }, [])}
    </ul>
  );
};

CogMenu.propTypes = {
  result: PropTypes.object.isRequired,
  classes: PropTypes.string,
  nextLevel: PropTypes.object,
  prevLevel: PropTypes.object
};

CogMenu.defaultProps = {
  classes: ''
};

export default CogMenu;
